import React, { useState, useRef, useEffect } from "react";
import { FontIcon } from "@/app/_components";
import {AddressComData} from "@/app/(redeem)/components/AddressComConfig";
import styles from "./AddressCom.module.css";

interface AddressComProps {
    onChange: (data: AddressData) => void;
    initData: AddressData;
}

export interface AddressData {
    country: string;
    state: string;
    city: string;
}

const AddressCom: React.FC<AddressComProps> = ({ initData, onChange }) => {
    const [country, setCountry] = useState<string>("");
    const [state, setState] = useState<string>(initData.state || "");
    const [city, setCity] = useState<string>(initData.city || "");

    const [isCountryOpen, setIsCountryOpen] = useState<boolean>(false);
    const [isStateOpen, setIsStateOpen] = useState<boolean>(false);
    const [isCityOpen, setIsCityOpen] = useState<boolean>(false);

    const countries = Object.keys(AddressComData);
    const [countriesState, setCountriesState] = useState<string[]>([]);

    const states = [] as string[];
    // const cities = ["Los Angeles", "Miami", "Houston", "New York City"];

    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        function handleClickOutside(event: MouseEvent | TouchEvent) {
            if (ref.current && !ref.current.contains(event.target as Node)) {
                hideAll();
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        document.addEventListener('touchstart', handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
            document.removeEventListener("touchstart", handleClickOutside);
        };
    }, []);

    const handleSelect = (type: "country" | "state" | "city", value: string) => {
        let newValues = { country, state, city };

        switch (type) {
            case "country":
                setCountry(value);
                setState(""); // Reset state and city when country changes
                setCity("");
                newValues.country = value;
                newValues.state = "";
                newValues.city = "";
                if (value !== "") {
                    console.log(value)
                    setCountriesState(AddressComData[value])
                }
                break;
            case "state":
                setState(value);
                setCity(""); // Reset city when state changes
                newValues.state = value;
                break;
            case "city":
                setCity(value);
                newValues.city = value;
                break;
        }
        onChange(newValues);
        hideAll();
    };

    const hideAll = () => {
        setIsCountryOpen(false);
        setIsStateOpen(false);
        setIsCityOpen(false);
    };

    return (
        <div className={styles.container} ref={ref}>
            <div className={styles.formGroup}>
                <label htmlFor="country" className={styles.label}>
                    Country:
                </label>
                <div className={styles.customDropdown}>
                    <input
                        type="text"
                        id="country"
                        value={country}
                        placeholder="Select Country"
                        readOnly
                        onClick={() => setIsCountryOpen(!isCountryOpen)}
                        className={styles.input}
                    />
                    <FontIcon
                        icon={`ani ${styles.shrink} ${
                            isCountryOpen ? "s-shrink-top" : "s-shrink-bottom"
                        }`}
                        click={() => setIsCountryOpen(!isCountryOpen)}
                    />
                    {isCountryOpen && (
                        <div className={styles.dropdownList}>
                            {countries.map((item) => (
                                <div
                                    key={item}
                                    className={styles.dropdownItem}
                                    onClick={() => handleSelect("country", item)}
                                >
                                    {item}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>

            <div className={styles.formGroup}>
                <label htmlFor="state" className={styles.label}>
                    State/Province:
                </label>
                <div className={styles.customDropdown}>
                    <input
                        type="text"
                        id="state"
                        value={state}
                        placeholder="Select State"
                        readOnly
                        onClick={() => setIsStateOpen(!isStateOpen)}
                        className={styles.input}
                    />
                    <FontIcon
                        icon={`${styles.shrink} ${
                            isStateOpen ? "s-shrink-top" : "s-shrink-bottom"
                        }`}
                        click={() => setIsStateOpen(!isStateOpen)}
                    />
                    {isStateOpen && (
                        <div className={styles.dropdownList}>
                            {countriesState.map((item) => (
                                <div
                                    key={item}
                                    className={styles.dropdownItem}
                                    onClick={() => handleSelect("state", item)}
                                >
                                    {item}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>

            <div className={styles.formGroup}>
                <label htmlFor="city" className={styles.label}>
                    City:
                </label>
                <div className={styles.customDropdown}>
                    <input
                        type="text"
                        id="city"
                        value={city}
                        placeholder="Your City"
                        // readOnly
                        onClick={() => setIsCityOpen(!isCityOpen)}
                        className={styles.input}
                        onChange={(e) => handleSelect("city", e.target.value)}
                    />
                    {/*<FontIcon*/}
                    {/*    item={`${styles.shrink} ${*/}
                    {/*        isCityOpen ? "s-shrink-top" : "s-shrink-bottom"*/}
                    {/*    }`}*/}
                    {/*    click={() => setIsCityOpen(!isCityOpen)}*/}
                    {/*/>*/}
                    {/*{isCityOpen && (*/}
                    {/*    <div className={styles.dropdownList}>*/}
                    {/*        {cities.map((item) => (*/}
                    {/*            <div*/}
                    {/*                key={item}*/}
                    {/*                className={styles.dropdownItem}*/}
                    {/*                onClick={() => handleSelect("city", item)}*/}
                    {/*            >*/}
                    {/*                {item}*/}
                    {/*            </div>*/}
                    {/*        ))}*/}
                    {/*    </div>*/}
                    {/*)}*/}
                </div>
            </div>
        </div>
    );
};

export default AddressCom;
